<template>
    <swiper ref="swiper" class="swiper catalog-swiper" :options="swiperOptionsAnimal" >
        <swiper-slide v-for="(item,index) in photos"  :key="index">

            <div class="product__thumbnail">
                <div v-if="!!item.path" class="product__thumbnail-image"
                     :style="'background-image: url(/storage/'+  useConvertImages(item.path,'full_s') +')'"></div>
            </div>

        </swiper-slide>
        <div :class="`swiper-pagination`" slot="pagination"></div>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
    name: "CatalogSlider",
    props: ['photos', 'idx', 'type'],
    components: {Swiper, SwiperSlide},
    data(){
        return{
            swiperOptionsAnimal: {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
        }
    },

    methods:{
        useConvertImages( path, replacer ){
            return this.$options.filters.convertImage(path, replacer)
        }
    }


}
</script>


<style lang="scss">

.catalog-swiper{
    .swiper-pagination-bullet{
        width: 10px;
        height: 10px;
    }

    .swiper-pagination-bullet-active{
        background: #2e76e4;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{
        margin: 0 6px;
    }
}

</style>

<style lang="scss" scoped>
    .product .product__thumbnail:before{
        display: none !important;
    }


    .swiper-pagination-fraction, .swiper-pagination-custom,
    .swiper-container-horizontal > .swiper-pagination-bullets{
        bottom: 0;
        margin-bottom: 5px;
    }

</style>
